<template>
  <div class="main-r-wrap">
    <div class="main-r-top">
      <span
        class="main-r_top_nav"
        :class="mainStatus === 'online' && 'active'"
        @click.stop="handleClick('online')"
      >在线文档</span>
      <!-- <span
        class="main-r_top_nav"
        :class="mainStatus === 'apiTest' && 'active'"
        @click.stop="handleClick('apiTest')"
      >测试工具</span> -->
    </div>
    <!-- 在线文档 START -->
    <div class="main-r-bottom" v-show="mainStatus === 'online'">
      <online-doc :onlineData="onlineData"></online-doc>
    </div>
    <!-- 在线文档 END -->
    <!-- 测试工具 START -->
    <div class="main-r-bottom" v-show="mainStatus === 'apiTest'">
      <api-test-doc :apiTestData="apiTestData"></api-test-doc>
    </div>
    <!-- 测试工具 END -->
  </div>
</template>

<script>
import onlineDoc from "../components/onlineDoc";

import apiTestDoc from "../components/apiTestDoc";

import {OPEN_API_TEST,OPEN_API_PRO} from '@/constants/index'
const apiUrlTest = 'order/addOrderFirstSegment';
export default {
  components: { onlineDoc , apiTestDoc },
  data() {
    return {
      mainStatus: "online",
      //当前请求URL
      apiBaseUrl: process.env.VUE_APP_API_URL + `/${apiUrlTest}`,

      onlineData: {
        //接口描述
        apiDesc: "接收入疆一段单信息，用于做二段单生成",
        //接口地址
        testApi: `${OPEN_API_TEST}/${apiUrlTest}`,
        proApi: `${OPEN_API_PRO}/${apiUrlTest}`,
        //参数描述  START
        postDataList:[

          //   请求头参数
          {
            title:'Headers',
            value:[
              {name: "apiAccount",type: "Number",require: "Y",normal: "",describe: "接入方在平台的api账户标识",},
              {name: "digest",type: "String",require: "Y",normal: "",describe: "签名字符串",},
              {name: "timestamp",type: "Number",require: "Y",normal: "",describe: "时间戳，毫秒",},
            ]
          },
          {
            title:'请求参数',
            value:[
              {name: "bizContent",type: "String",require: "Y",normal: "业务参数",describe: "业务参数模块内json格式的string类型",},
            ]
          },
          {
            title:"业务参数",
            value:[
              {name: "billCode",type: "String",require: "Y",normal: "bill_code",describe: "运单号"},
              {name: "expressCompany",type: "String",require: "Y",normal: "中通",describe: "快递公司"},
              {name: "senderName",type: "String",require: "Y",normal: "晏",describe: "寄件人"},
              {name: "senderMobilePhone",type: "String",require: "Y",normal: "186****808",describe: "寄件人手机"},
              {name: "senderProvinceName",type: "String",require: "Y",normal: "江苏省",describe: "寄件省"},
              {name: "senderCityName",type: "String",require: "Y",normal: "南京市",describe: "寄件市"},
              {name: "senderAreaName",type: "String",require: "Y",normal: "玄武区",describe: "寄件区/县"},
              {name: "senderDetailedAddress",type: "String",require: "Y",normal: "南京玄武网点",describe: `寄件详细地址`},
              {name: "transitWarehouseProvinceName",type: "String",require: "Y",normal: "陕西省",describe: `中转仓所属省`},
              {name: "transitWarehouseCityName",type: "String",require: "Y",normal: "西安市",describe: `中转仓所属市`},
              {name: "transitWarehouseAreaName",type: "String",require: "Y",normal: "未央区",describe: `中转仓所属区/县`},
              {name: "transitWarehouseDetailedAddress",type: "String",require: "Y",normal: "详细地址",describe: `中转仓所属详细地址`},
              {name: "operateType",type: "int",require: "Y",normal: `01：新增 02：更新（已生成二段单号后不允许更新） 03：取消（已生成二段单号后不允许取消）`,describe: `操作类型`},
              {name: "receiverName",type: "String",require: "Y",normal: "晏",describe: "收件人"},
              {name: "receiverMobilePhone",type: "String",require: "Y",normal: "186****808",describe: "收件手机"},
              {name: "receiverProvinceName",type: "String",require: "Y",normal: "上海",describe: "收件省"},
              {name: "receiverCityName",type: "String",require: "Y",normal: "上海市",describe: "收件市"},
              {name: "receiverAreaName",type: "String",require: "Y",normal: "青浦区",describe: "收件区/县"},
              {name: "receiverDetailedAddress",type: "String",require: "Y",normal: "E通世界华新园",describe: "收件详细地址"},
              {name: "packageChargeWeight",type: "String",require: "N",normal: "1",describe: "重量"}
            ]
          }
        ],
        //参数描述  END
        //报文描述 start
        responseDataList:[

          //   响应参数
          {
            title:'响应参数',
            value:[
              { name: "code",type: "String", require: "Y",normal: "",describe: "返回码，见附录"},
              {name: "msg",type: "String",require: "Y",normal: "",describe: "描述"}
            ]
          },
        ],
        //请求示例
        requestCode: `Header：
    apiAccount=1627
    digest=U40e5sumorgd3YgZzU61Mw==
    timestamp=1565238848921

Body：
    bizContent = {
        "billCode": bill_code,
        "expressCompany": "极兔",
        "senderName": "晏",
        "senderMobilePhone": "18625354808",
        "senderProvinceName": "江苏省",
        "senderCityName": "南京市",
        "senderAreaName": "玄武区",
        "senderDetailedAddress": "南京玄武网点",
        "transitWarehouseProvinceName":"陕西省",
        "transitWarehouseCityName":"西安市",
        "transitWarehouseAreaName":"未央区",
        "transitWarehouseDetailedAddress":"西安玄武网点",
        "operateType":1,
        "receiverName": "晏",
        "receiverMobilePhone": "18625354808",
        "receiverProvinceName": "上海",
        "receiverCityName": "上海市",
        "receiverAreaName": "青浦区",
        "receiverDetailedAddress": "E通世界华新园",
        "packageChargeWeight": "1",
    }`,
        //返回示例
        responseCode: JSON.parse(`{
    "code": "1",
    "msg": "success"
}
`),


        //错误代码提示
        errcodeJson: []
      },

      apiTestData: {
        _headerData: {
          apiAccount: "1001",
          digest: "U40e5sumorgd3YgZzU61Mw==",
          timestamp: "1565238848921",
        },
        data:{
          bizContent: `{"customerCode":"J0086000020","digest":"/bGMxZbpzAtLrplAvEYvqw==","serviceType":"02","countryCode":"CHN","orderType":"2","receiver":{"area":"鼓楼区","address":"南京大学","town":"鼓楼镇","city":"南京市","mobile":"12345678909","mailBox":"ant_li123@qq.com","phone":"075587654321","countryCode":"CHN","street":"大学路","name":"中露姐1","company":"上海天美工作室","postCode":"518000","prov":"江苏省"},"expressType":"EZ","deliveryType":"03","length":30,"sendStartTime":"2020-01-18 15:05:47","weight":20,"remark":"YD9945874130030","txlogisticId":"YL101010101011","goodsType":"bm000001","volume":210,"priceCurrency":"RMB","totalQuantity":6,"sender":{"area":"雨花台区","address":"高新技术产业园","town":"粤海街道","city":"南京市","mobile":"12345678909","mailBox":"ant_li@qq.com","phone":"075512345678","countryCode":"CHN","street":"高新南七道","name":"小露姐1","company":"深圳天丑工作室","postCode":"518000","prov":"江苏省"},"itemsValue":"2000","width":10,"offerFee":1000,"items":[{"englishName":"文件111","number":30,"itemType":"bm000001","itemName":"文件222","priceCurrency":"RMB","itemValue":"2000","chineseName":"文件333","itemUrl":"http://www.baidu.com/#h%?a=10&b=20","desc":"文件"},{"englishName":"文件444","number":50,"itemType":"bm000001","itemName":"文件555","priceCurrency":"RMB","itemValue":"3000","chineseName":"文件666","itemUrl":"http://www.baidu.com/#h%?a=10&b=20","desc":"文件000"}],"sendEndTime":"2020-01-19 15:05:47","height":600}`
        },
        //必须要验证的参数
        requestData:['apiAccount','digest','timestamp','bizContent'],
        textareaData:{
          bizContent:true
        },
        //促发接口
        apiUrl: `/mock/${apiUrlTest}`,
        //返回
        ResponseJson: "",
        //当前请求URL
        apiBaseUrl: process.env.VUE_APP_API_URL + `/mock/${apiUrlTest}`,


        //错误代码提示
        errcodeJson: [
          {code:'145003031',msg:"业务参数签名失败"},
          {code:'145002002',msg:"运单重复,请勿使用相同运单号！"},{code:'145003042',msg:"修改订单失败"},{code:'145003111',msg:"批次号无效！"},
          {code:'145003060',msg:"区域不合法"},{code:'145003061',msg:"城市不合法"},{code:'145003062',msg:"省份不合法"},
          {code:'145003064',msg:"查不到数据"},{code:'145003041',msg:"下单失败"},{code:'145003083',msg:"发件人信息不全"},
          {code:'145003112',msg:"该批次号运单无效！"},{code:'145002001',msg:"订单重复,无需重复下单！"},{code:'145003084',msg:"收件人信息不全"},
          {code:'145003085',msg:"电话号码不能为空"},{code:'145003086',msg:"地址信息不全"},{code:'145003087',msg:"请检查订单类型、服务类型、派送类型、物品类型、快件类型、结算方式是否合法"},
          {code:'145003200',msg:"请检查服务类型是否合法值为 01或 02"},{code:'145003088',msg:"上门服务时间信息不全"},{code:'145003092',msg:"重量信息不合法"},
          {code:'145003093',msg:"物品信息不全"},{code:'145003094',msg:"物品名称不全"},{code:'145003095',msg:"物品类型不全"},
          {code:'145003096',msg:"物品数量非法"},{code:'145003099',msg:"非法金额"},{code:'145003100',msg:"运单号非法"},
          {code:'145003101',msg:"客户订单号已存在,无法下单！"},{code:'145003103',msg:"姓名信息非法"},{code:'145003104',msg:"公司信息过长"},
          {code:'145003105',msg:"联系信息过长"},{code:'145003106',msg:"邮编或邮箱信息非法"},{code:'145003107',msg:"价格信息非法"},
          {code:'145003108',msg:"备注、描述、链接信息非法"},{code:'145003109',msg:"地址信息过长"},{code:'145003110',msg:"街道信息过长"},
          {code:'145003111',msg:"包裹总件数无效"},{code:'145003112',msg:"暂未开通代收货款业务"},{code:'145003113',msg:"支付方式不匹配,PP_CASH,PP_MM"},
          {code:'145003201',msg:"已取件状态不可修改"},{code:'145003202',msg:"已取消状态不可修改"},{code:'145003203',msg:"更新订单失败，请稍后重试！"},
          {code:'145003083',msg:"始发地信息不全"},{code:'145003084',msg:"收货地信息不全"},
          {code:'145003340',msg:"驿站编码只能英文与数字"},{code:'145003341',msg:"驿站编码最长20字符"},
          {code:'145003342',msg:"驿站名称最长100字符"},{code:'145003343',msg:"驿站地址最长200字符"}]
      },
    };
  },
  created() {},
  methods: {
    handleClick(status) {
      this.mainStatus = status;
    }
  },
};
</script>

<style lang="scss" scoped>
@import "../../css/apiTest.scss";
</style>
